import yup, { statusValidator } from '~/utils/validators.yup';

export const statusDetailRule = {
    statusDetail: yup.object().shape({
        playerStatuses: statusValidator,
        opponentStatuses: statusValidator,
    }),
};
